import React, { useState, useRef } from 'react'
import { Validaciones } from '@renedelangel/helpers';

// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';

// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import FlagIcon from '@material-ui/icons/Flag';

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';
import { rgxNumeros } from '../../../helpers/regexp';

import * as Permisos from '../Permisos';

const { trim } = Validaciones;

// Longitud de la columna NOMBRE y valor maximo de ORDEN (TINYINT) en las tablas de estados
const maxNombre = 30;
const maxOrden = 127;
// El color se guarda en formato hexadecimal, p. ej. #4CAF50
const rgxColor = /^#[0-9A-F]{6}$/;

// Muestra del color para la tabla del catálogo: solo el color (el código aparece al pasar el cursor).
// Si el código no es válido se deja el texto para que se note
function ftMuestraColor(color) {
    if (!color || !rgxColor.test(String(color).toUpperCase())) return color ? String(color) : "";
    return <span
        title={String(color).toUpperCase()}
        style={{ width: "40px", height: "18px", backgroundColor: color, border: "1px solid #BDBDBD", borderRadius: "3px", display: "inline-block" }}
    />;
}

// Catalogo comun para los estados de seguimiento de seguros y de siniestros;
// cada uno le pasa sus consultas y el titulo de la pantalla
function CatalogoEstadosSeguimiento({ titulo, asyncGet, asyncTabla, asyncAdd, asyncUpdate, asyncDelete }) {

    const { token } = useSelector(state => state.login);

    const cleanState = {
        estadoID: null,
        nombre: "",
        color: "",
        esFinal: false,
        orden: ""
    };
    const cleanErrorState = {
        nombre: { error: false, helperText: "" },
        color: { error: false, helperText: "" },
        orden: { error: false, helperText: "" }
    }

    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [state, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);

    let titleAccion = state.estadoID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} Estado de Seguimiento`;

    const nombreRef = useRef(null);
    const colorRef = useRef(null);
    const ordenRef = useRef(null);

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "estadoID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert, asyncGet,
            // El orden llega como numero y el color puede venir vacio; los campos del formulario son texto
            formatearResultado: [
                { id: "orden", formato: (orden) => orden === null || orden === undefined ? "" : String(orden) },
                { id: "color", formato: (color) => color ? color : "" },
                { id: "esFinal", formato: (esFinal) => !!esFinal }
            ]
        })
    }, {
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "estadoID" }, { campo: "nombre" }],
        disabled: { multiseleccion: true },
        onClick: ({ estadoID, nombre }) => handelAlertEliminar({
            setAlert,
            mensaje: ` el estado de seguimiento ${nombre}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { estadoID }, asyncDelete
            })
        })
    }];

    let botones = [
        {
            accionID: [2],
            icono: Add,
            color: success,
            descripcion: "Agregar",
            onClick: () => setOpen(true),
            disabled: { multiseleccion: true }
        }, {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        }];

    const infoTabla = {
        botones,
        acciones,
        loader,
        actualizar,
        id: "estadoID",
        color: primary,
        title: titulo,
        iconTable: <FlagIcon />,
        headers: [
            { variable: "estadoID", descripcion: "EstadoID", hide: true },
            { variable: "nombre", descripcion: "Estado de Seguimiento" },
            { variable: "color", descripcion: "Color" },
            { variable: "esFinalTexto", descripcion: "Cierra el seguimiento" },
            { variable: "orden", descripcion: "Orden" }
        ],
        responsiveTitle: ["nombre"],
        filter: [
            { campo: "nombre" }
        ],
        formato: [
            { columnas: ["color"], tipo: "custom", callback: (valor) => ftMuestraColor(valor) }
        ],
        alineacion: [{ columnas: [0, 1], alineacion: "left" }, { columnas: [2, 3, 4], alineacion: "center" }]
    }

    const inputs = [
        {
            id: "Arriba",
            tipo: "fieldset",
            grid: { lg: 12 },
            inputs: [
                {
                    disabled,
                    id: "nombre",
                    value: state.nombre,
                    error: errorState.nombre.error,
                    success: state.nombre && !errorState.nombre.error ? true : undefined,
                    helperText: errorState.nombre.helperText,
                    inputRef: nombreRef,
                    title: "Estado de Seguimiento *",
                    placeholder: "Capture el nombre del estado",
                    grid: { md: 12, lg: 12 },
                    onChange: ({ target: { value } }) => handleChange(value.toUpperCase(), "nombre"),
                    onKeyDown: () => { return; }
                },
                {
                    // Selector de color del navegador: se elige con el mouse, sin capturar el código
                    id: "color",
                    tipo: "custom",
                    grid: { md: 4, lg: 4 },
                    custom: <div style={{ marginTop: "12px" }}>
                        <div style={{ fontSize: "12px", color: errorState.color.error ? "#F44336" : "#757575", marginBottom: "4px" }}>Color</div>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <input
                                ref={colorRef}
                                type="color"
                                title="Elegir color"
                                disabled={disabled}
                                value={rgxColor.test(state.color || "") ? state.color : "#FFFFFF"}
                                onChange={({ target: { value } }) => handleChange(value.toUpperCase(), "color")}
                                style={{ width: "56px", height: "32px", padding: 0, border: "1px solid #BDBDBD", borderRadius: "4px", background: "none", cursor: disabled ? "default" : "pointer" }}
                            />
                            <span style={{ fontSize: "13px", color: "#424242" }}>{state.color ? state.color : "Sin color"}</span>
                            {state.color && !disabled && <button
                                type="button"
                                onClick={() => handleChange("", "color")}
                                style={{ border: "none", background: "none", color: "#1976D2", cursor: "pointer", padding: 0, fontSize: "12px" }}
                            >Quitar</button>}
                        </div>
                        {errorState.color.error && <div style={{ fontSize: "12px", color: "#F44336", marginTop: "4px" }}>{errorState.color.helperText}</div>}
                    </div>
                },
                {
                    disabled,
                    id: "orden",
                    value: state.orden,
                    error: errorState.orden.error,
                    success: state.orden && !errorState.orden.error ? true : undefined,
                    helperText: errorState.orden.helperText,
                    inputRef: ordenRef,
                    title: "Orden",
                    placeholder: "Posición en los listados",
                    grid: { md: 4, lg: 4 },
                    onChange: ({ target: { value } }) => handleChange(value.replace(/[^0-9]/g, ""), "orden"),
                    onKeyDown: () => { return; }
                },
                {
                    disabled,
                    id: "esFinal",
                    value: state.esFinal,
                    checked: state.esFinal,
                    title: "Cierra el seguimiento",
                    tipo: "switch",
                    grid: { md: 4, lg: 4 },
                    onChange: (e) => handleChange(e.target.checked, "esFinal")
                }
            ]
        }
    ];

    let accionesFormulario = [{
        accionID: state.estadoID ? [3] : [2],
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: nombreRef,
            mensajeCorrecto: `El estado de seguimiento se ${state.estadoID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleValidaciones({ nombre, color, orden }) {

        let error;
        let validaciones = [
            {
                condicion: !nombre || trim(nombre) === "",
                ref: nombreRef, keyError: "nombre",
                mensajeError: "Debe especificar el nombre del estado de seguimiento"
            },
            {
                condicion: trim(nombre).length > maxNombre,
                ref: nombreRef, keyError: "nombre",
                mensajeError: `El nombre no debe exceder de ${maxNombre} caracteres`
            },
            {
                condicion: color !== "" && !rgxColor.test(color),
                ref: colorRef, keyError: "color",
                mensajeError: "El color debe tener el formato #RRGGBB, p. ej. #4CAF50"
            },
            {
                condicion: orden !== "" && (!rgxNumeros.test(orden) || Number(orden) > maxOrden),
                ref: ordenRef, keyError: "orden",
                mensajeError: `El orden debe ser un número entre 0 y ${maxOrden}`
            }
        ];
        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function ftGuardar() {
        async function ftGuardar() {

            let { estadoID, nombre, color, esFinal, orden } = state;
            color = color ? trim(color) : "";
            orden = orden === null || orden === undefined ? "" : String(orden);

            let error = await handleValidaciones({ nombre, color, orden });

            if (error) return error;

            let input = {
                nombre: trim(nombre),
                color: color === "" ? null : color,
                esFinal: !!esFinal,
                orden: orden === "" ? null : Number(orden)
            };

            if (estadoID) await asyncUpdate({ input: { estadoID, ...input } }, token);
            else await asyncAdd({ input }, token);

        }
        return ftGuardar();
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key) { setState({ ...state, [key]: value }); }

    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    } else {
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    return (<>
        <Tabla
            infoTabla={infoTabla}
            asyncData={asyncTabla}
            token={token}
        />
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            maxWidth={false}
            acciones={accionesFormulario}
            focus={nombreRef}
        />
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);

}

export default CatalogoEstadosSeguimiento;
